<template>
  <CrudForm
    :title="title"
    :labelSubmit="labelSubmit"
    :storeName="storeName"
    parentStoreName="Terms"
    :submit="submit"
    :status="status"
  >
    <ValidationObserver ref="validator" v-slot="{}">
      <v-row justify="center">
        <v-col cols="6">
          <v-row>
            <v-col>
              <ValidationProvider
                ref="title"
                rules="required"
                v-slot="{ errors }"
              >
                <v-text-field
                  :error-messages="errors"
                  v-model="data.title"
                  label="Titulo"
                  ></v-text-field>
              </ValidationProvider>
            </v-col>
          </v-row>
          <v-row>
             <v-col>
              <label>Descripcion</label>
              <ValidationProvider
                  ref="description"
                  rules="required"
                  v-slot="{ errors }"
              >
                <v-textarea
                    :error-messages="errors"
                    v-model="data.description"
                    solo
                />
              </ValidationProvider>
            </v-col>
          </v-row>
        </v-col>
      </v-row>
    </ValidationObserver>
  </CrudForm>
</template>

<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Upload from "@/components/Upload";
import CrudForm from "@/components/Crud/CrudForm";
import CrudFormMixin from "@/mixins/crud_form";

export default {
  mixins: [CrudFormMixin],
  components: { CrudForm, ValidationProvider, Upload, ValidationObserver },
  data() {
    return {
      storeName: "Terms",
      title: "Terminos y Condiciones",
      data: {
        title: "",
        description:"",

      },
    };
  },
  computed: {
    ...mapState({
      status: (state) => state.Terms.status,
    }),
  },
  watch: {

  },
  methods: {

  },
};
</script>
